<template>
  <div></div>
</template>
<script lang="ts">
import Vue from "vue";
import aws_config from "../aws-config";

export default Vue.extend({
  created() {
    this.$store.dispatch("signout");

    var domain = aws_config().DOMAIN;
    var clientId = aws_config().CLIENT_ID;
    var type = "code";
    var state = this.$store.state.auth.verification;
    var scope = "openid email profile";
    var callback =
      window.location.protocol + "//" + window.location.host + "/tokenize";

    window.location.href =
      "https://" +
      domain +
      "/logout?response_type=" +
      type +
      "&client_id=" +
      clientId +
      "&redirect_uri=" +
      callback +
      "&state=" +
      state +
      "&scope=" +
      scope;
  },
});
</script>